import { useParams } from 'react-router-dom';
import { useRef, useState } from 'react';
import VehicleModelsEditColor from './VehicleModelsEditColor';
import SectionHeader from '../../../../components/SectionHeader';
import useFormsIntegrationHelpers from '../../../../hooks/useFormsIntegrationHelpers';

export default function VehicleModelsEditExterior({ title, interior, variant }: { title: string; interior?: boolean; variant?: boolean }) {
  const { id, modelId, variantId } = useParams();
  const formRef = useRef(null);
  const [expanded, setExpanded] = useState(0);

  const { apiData } = useFormsIntegrationHelpers({
    id,
    queryKey: variant ? ['variants', variantId] : ['models', modelId],
    singleGetApi: variant ? `/admin/variants/${variantId}` : `/admin/makes/${id}/models/${modelId}`
  });

  const data = apiData?.[`${interior ? 'interior' : 'exterior'}_colors`];

  return (
    <div className={'model_gallery model_exterior_images form_section'} ref={formRef}>
      <SectionHeader title={title} customStyle="last">
        <div className="accordions-container">
          {data?.map((item: any, index: number) => {
            return <VehicleModelsEditColor expanded={expanded} setExpanded={setExpanded} interior={interior} data={item} index={index} variant={variant} />;
          })}
          <VehicleModelsEditColor
            key={`${interior ? 'interior' : 'exterior'}_color_add`}
            expanded={expanded}
            setExpanded={setExpanded}
            interior={interior}
            add
            index={data?.length || 0}
            variant={variant}
          />
        </div>
      </SectionHeader>
    </div>
  );
}
